import { Type } from "@sinclair/typebox";
const position = Type.Tuple([
    Type.Number({ minimum: -180, maximum: 180 }),
    Type.Number({ minimum: -90, maximum: 90 })
]);
const polygon = Type.Array(Type.Array(position, { minItems: 4 }), { minItems: 1 });
const geometry = Type.Union([
    Type.Object({ type: Type.Literal("Polygon"), coordinates: polygon }),
    Type.Object({
        type: Type.Literal("MultiPolygon"),
        coordinates: Type.Array(polygon, { minItems: 1 })
    })
]);
const nullableText = Type.Union([Type.String(), Type.Null()]);
export const buildingVolumeSchema = Type.Object({
    id: Type.String(),
    buildingPartId: Type.String(),
    sourceId: Type.String(),
    geometry: Type.Union([geometry, Type.Null()]),
    heightM: Type.Union([Type.Number({ exclusiveMinimum: 0 }), Type.Null()]),
    heightStatus: Type.Union([Type.Literal("indicative"), Type.Literal("unavailable")]),
    exclusionReason: Type.Union([
        Type.Literal("missing_height"),
        Type.Literal("invalid_height"),
        Type.Literal("invalid_geometry"),
        Type.Literal("unsupported_portion"),
        Type.Null()
    ]),
    source: Type.Object({
        name: Type.String(),
        releaseKey: Type.String(),
        observedAt: nullableText,
        reference: nullableText
    })
});
/** Availability concerns renderable UVLs, never completeness of the building footprint. */
export const buildingVolumesSchema = Type.Object({
    buildingId: Type.String(),
    status: Type.Union([
        Type.Literal("available"),
        Type.Literal("partial"),
        Type.Literal("unavailable")
    ]),
    footprint: Type.Optional(Type.Union([geometry, Type.Null()])),
    units: Type.Array(buildingVolumeSchema)
});
//# sourceMappingURL=building-volumes.js.map